import React from 'react';
import { Users } from 'lucide-react';
import AboutEstetoImage from '../assets/vista-aerea.svg';
import '../index.css';

export const About = () => {
  return (
    <section className="py-20 bg-main relative overflow-hidden">
      {/* Transversal Decorator */}
      <div className="absolute inset-0 z-0">
        <div className="absolute left-1/2 -translate-x-1/3 top-0 w-[150%] h-full bg-gradient-to-r from-accent/5 to-primary/5 transform -rotate-12 -skew-y-12 origin-top-right" />
      </div>

      {/* Floating Particles Decorator */}
      <div className="absolute inset-0 z-0 overflow-hidden">
        {[...Array(30)].map((_, i) => (
          <div
            key={i}
            className="absolute w-2 h-2 bg-accent/20 rounded-full animate-float"
            style={{
              top: `${Math.random() * 100}%`,
              left: `${Math.random() * 100}%`,
              animationDuration: `${Math.random() * 10 + 5}s`,
              animationDelay: `${Math.random() * 5}s`,
            }}
          />
        ))}
      </div>

      <div className="container mx-auto px-6 relative z-10">
        <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-20">
          {/* Image Section */}
          <div className="relative w-full lg:w-2/5 xl:w-1/3">
            <div className="relative group">
              <div className="absolute inset-0 bg-gradient-to-br from-primary/30 to-accent/30 rounded-3xl transform rotate-3 scale-105 transition-transform duration-500 group-hover:rotate-6" />
              <div className="relative overflow-hidden rounded-2xl shadow-lg transform hover:scale-[1.02] transition-all duration-300 border-8 border-white/10">
                <img
                  src={AboutEstetoImage}
                  alt="Equipos médicos"
                  className="w-full h-[400px] object-cover bg-no-repeat"
                  style={{ backgroundRepeat: 'no-repeat', backgroundSize: 'cover' }}
                />
                <div className="absolute inset-0 bg-gradient-to-t from-dark/50 to-transparent" />
                {/* Floating Badge */}
                <div className="absolute bottom-6 left-1/2 -translate-x-1/2 bg-accent px-8 py-3 rounded-full shadow-md border border-gray-100">
                  <span className="font-poppins font-bold text-white">Desde 2003</span>
                </div>
              </div>
            </div>
          </div>

          {/* Content Section */}
          <div className="flex-1 space-y-8">
            <div className="flex items-center gap-4 group cursor-pointer hover:-translate-x-2 transition-transform duration-300">
              <div className="p-3 bg-primary/10 rounded-full transform transition-transform group-hover:scale-110 group-hover:bg-accent/20">
                <Users className="h-7 w-7 text-primary-dark group-hover:text-accent" />
              </div>
              <span className="text-primary-dark text-center font-poppins font-semibold uppercase tracking-wider text-lg md:text-xl">
                Nuestra Trayectoria
              </span>
            </div>

            <h2 className="text-3xl md:text-5xl text-center xl:text-6xl font-bold text-dark font-poppins leading-tight">
              Innovación Médica <br className="hidden lg:block" />
              <span className="bg-gradient-to-r from-primary-dark to-accent bg-clip-text text-transparent">
                con Propósito
              </span>
            </h2>

            <p className="text-lg md:text-xl text-gray-700 leading-relaxed font-montserrat max-w-3xl">
              Por más de dos décadas, hemos sido pioneros en la evolución de tecnología médica, combinando conocimiento especializado con un compromiso inquebrantable con la excelencia. Nuestra filosofía se basa en tres pilares fundamentales:
            </p>

            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {[
                { title: 'Calidad Certificada', desc: 'Equipos médicos con los más altos estándares internacionales' },
                { title: 'Experiencia Práctica', desc: 'Profesionales que utilizan diariamente la tecnología que recomendamos' },
                { title: 'Innovación Continua', desc: 'Actualización constante con las últimas tecnologías médicas' },
                { title: 'Soporte Integral', desc: 'Acompañamiento técnico y formación especializada post-venta' },
              ].map((item, index) => (
                <div
                  key={index}
                  className="p-6 bg-white/70 backdrop-blur-lg rounded-xl border-2 border-gray-100/50 hover:border-accent/30 hover:shadow-lg transition-all duration-300 group hover:-translate-y-2"
                >
                  <div className="flex items-center gap-4 mb-3">
                    <div className="w-3 h-3 bg-accent rounded-full group-hover:scale-150 transition-transform duration-300" />
                    <h3 className="font-poppins font-bold text-lg text-primary-dark group-hover:text-accent transition-colors duration-300">
                      {item.title}
                    </h3>
                  </div>
                  <p className="text-gray-700 font-montserrat text-base pl-7">
                    {item.desc}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>

      {/* Animated Gradient Border */}
      <div className="absolute inset-x-0 bottom-0 h-2 bg-gradient-to-r from-primary via-accent to-primary animate-gradient-x" />
    </section>
  );
};